import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

const SCALE_DIFFICOLTA = {
  '1': 'Nessuna difficoltà',
  '2': 'Lieve difficoltà',
  '3': 'Discreta difficoltà',
  '4': 'Notevole difficoltà',
  '5': 'Non ci sono riuscito',
};

const SCALE_SINTOMI = {
  '1': 'Nessuno',
  '2': 'Lieve',
  '3': 'Discreto',
  '4': 'Forte',
  '5': 'Estremo',
};

export const DASH_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.DASH, // Assicurati di aggiungere DASH al tuo SCALE_TYPE enum
  title: "Questionario per l'arto superiore DASH",
  scoreConfig: {
    scoreKey: 'dash_score_main',
    scoreFields: [
      'q1',
      'q2',
      'q3',
      'q4',
      'q5',
      'q6',
      'q7',
      'q8',
      'q9',
      'q10',
      'q11',
      'q12',
      'q13',
      'q14',
      'q15',
      'q16',
      'q17',
      'q18',
      'q19',
      'q20',
      'q21',
      'q22',
      'q23',
      'q24',
      'q25',
      'q26',
      'q27',
      'q28',
      'q29',
      'q30',
    ],
  },
  sections: [
    {
      name: 'capacita_fisica',
      label: 'Capacità Fisica (Settimana scorsa)',
      fields: [
        {
          key: 'q1',
          label: '1. Svitare il coperchio di un barattolo ben chiuso o nuovo.',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q2',
          label: '2. Scrivere',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q3',
          label: '3. Girare una chiave',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q4',
          label: '4. Preparare un pasto',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q5',
          label: '5. Aprire spingendo una porta pesante',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q6',
          label:
            '6. Posare un oggetto su uno scaffale al di sopra della propria testa',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q7',
          label:
            '7. Fare lavori domestici pesanti (es. lavare i pavimenti o i vetri)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q8',
          label: '8. Fare lavori di giardinaggio',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q9',
          label: '9. Rifare il letto',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q10',
          label: '10. Portare la borsa della spesa o una ventiquattrore',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q11',
          label: '11. Portare un oggetto pesante (oltre 5 Kg)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q12',
          label:
            '12. Cambiare una lampadina posta al di sopra della propria testa',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q13',
          label: '13. Lavarsi o asciugarsi i capelli',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q14',
          label: '14. Lavarsi la schiena',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q15',
          label: '15. Infilarsi un maglione',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q16',
          label: '16. Usare un coltello per tagliare del cibo',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q17',
          label:
            '17. Attività ricreative che richiedono poco sforzo (es. giocare a carte, lavorare a maglia)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q18',
          label:
            '18. Attività ricreative nelle quali si fa forza o si prendono colpi sul braccio, sulla spalla o sulla mano (es. usare il martello, giocare a tennis o a golf, ecc.)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q19',
          label:
            '19. Attività ricreative che richiedono un movimento libero del braccio (es. giocare a frisbee, a badminton, ecc.)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q20',
          label:
            '20. Far fronte alle necessità di spostamento (andare da un posto ad un altro)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q21',
          label: '21. Attività sessuale',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
      ],
    },
    {
      name: 'impatto_sociale_lavoro',
      label: 'Impatto Sociale e Lavorativo (Settimana scorsa)',
      fields: [
        {
          key: 'q22',
          label:
            '22. In che misura il problema ha interferito con le normali attività sociali con famiglia, amici, vicini o gruppi?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '1': 'Per nulla',
            '2': 'Molto poco',
            '3': "Un po'",
            '4': 'Molto',
            '5': 'Moltissimo',
          },
        },
        {
          key: 'q23',
          label:
            '23. È stato limitato nel suo lavoro o in altre attività quotidiane abituali a causa del problema?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '1': 'Non mi ha limitato per nulla',
            '2': 'Mi ha limitato leggermente',
            '3': 'Mi ha limitato discretamente',
            '4': 'Mi ha limitato molto',
            '5': 'Non ci sono riuscito',
          },
        },
      ],
    },
    {
      name: 'sintomi',
      label: 'Intensità dei Sintomi (Settimana scorsa)',
      fields: [
        {
          key: 'q24',
          label: '24. Dolore al braccio, alla spalla o alla mano',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_SINTOMI,
        },
        {
          key: 'q25',
          label: '25. Dolore nel compiere una qualsiasi attività specifica',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_SINTOMI,
        },
        {
          key: 'q26',
          label: '26. Formicolio (sensazione di punture di spillo)',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_SINTOMI,
        },
        {
          key: 'q27',
          label: '27. Debolezza al braccio, alla spalla o alla mano',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_SINTOMI,
        },
        {
          key: 'q28',
          label: '28. Rigidità del braccio, della spalla o della mano',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_SINTOMI,
        },
      ],
    },
    {
      name: 'sonno_psicologia',
      label: 'Sonno e Impatto Psicologico (Settimana scorsa)',
      fields: [
        {
          key: 'q29',
          label:
            '29. Quanta difficoltà ha incontrato nel dormire a causa del dolore?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '1': 'Nessuna difficoltà',
            '2': 'Lieve difficoltà',
            '3': 'Discreta difficoltà',
            '4': 'Notevole difficoltà',
            '5': 'Non sono riuscito a dormire',
          },
        },
        {
          key: 'q30',
          label:
            '30. Mi sento meno capace, meno fiducioso o meno utile a causa del problema',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '1': "Non sono assolutamente d'accordo",
            '2': "Non sono d'accordo",
            '3': 'Non saprei',
            '4': "Sono d'accordo",
            '5': "Sono assolutamente d'accordo",
          },
        },
      ],
    },
    {
      name: 'modulo_lavorativo',
      label: 'Modulo Lavorativo (Opzionale)',
      fields: [
        {
          key: 'q31',
          label:
            '31. Difficoltà a utilizzare la Sua tecnica abituale per lavorare?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q32',
          label:
            '32. Difficoltà a svolgere il Suo lavoro abituale a causa del dolore?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q33',
          label: '33. Difficoltà a fare il lavoro bene come vorrebbe?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q34',
          label:
            '34. Difficoltà a dedicare al Suo lavoro la consueta quantità di tempo?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
      ],
    },
    {
      name: 'modulo_sportivo',
      label: 'Modulo Attività Sportive/Ricreative (Opzionale)',
      fields: [
        {
          key: 'q35',
          label:
            '35. Difficoltà a utilizzare la Sua tecnica abituale per suonare/praticare?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q36',
          label: '36. Difficoltà a suonare/praticare a causa del dolore?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q37',
          label: '37. Difficoltà a suonare/praticare bene come vorrebbe?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
        {
          key: 'q38',
          label: '38. Difficoltà a dedicare la consueta quantità di tempo?',
          type: 'number',
          min: 1,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: SCALE_DIFFICOLTA,
        },
      ],
    },
  ],
  computedFields: [
    {
      key: 'dash_score_main',
      label: 'Punteggio DASH (Modulo Standard)',
      type: 'number',
      calculation: 'ROUND((AVG(scoreConfig.scoreFields) - 1) * 25, 2)',
      maxScore: 100,
    },
    {
      key: 'dash_score_work',
      label: 'Punteggio DASH (Modulo Lavorativo)',
      type: 'number',
      calculation: 'ROUND((AVG([q31, q32, q33, q34]) - 1) * 25, 2)',
      maxScore: 100,
    },
    {
      key: 'dash_score_sport',
      label: 'Punteggio DASH (Modulo Sport/Musica)',
      type: 'number',
      calculation: 'ROUND((AVG([q35, q36, q37, q38]) - 1) * 25, 2)',
      maxScore: 100,
    },
  ],
};
